export default {
    title: "Conferma di consegna",
    header: "@:views.survey.delivery.title",
    result: {
        header: "Grazie",
        message: "Grazie per la risposta."
    },
    status: {
        yes: "Si prega di verificare i prodotti selezionati qui sotto per confermare la consegna e di deselezionare quelli che non sono stati ricevuti. Quindi, fare clic su Invia per confermare.",
        no: "Verifica di non aver ricevuto nessuno dei prodotti elencati di seguito. Se hai ricevuto uno di questi prodotti, seleziona la casella accanto al/i prodotto/i ricevuto/i e clicca su Invia per confermare."
    },
    model: {
        checked: {
            label: "Ricevuto"
        }
    },
    button: {
        submit: {
            cta: "Invia",
            processing: "Invio"
        }
    }
}